export const API_ENDPOINTS = Object.freeze({
    LOGIN: "auth/login",
    LOGOUT: "auth/logout",

    GET_USERS: "admin/users",
    DELETE_USER: (userId) => `admin/users/${userId}`,
    UPDATE_USER: (userId) => `admin/users/update/${userId}`,

    GET_PRODUCTS: "products",
    GET_CATEGORIES: "categories",
    ADD_PRODUCT: "products/store",
    DELETE_PRODUCT: (productId) => `admin/products/${productId}`,
    GET_PRODUCT_VARIANTS: (productId) => `admin/products/${productId}/variants`,
    UPDATE_VARIANT_QUANTITY: (variantId) => `admin/products/variants/change-quantity/${variantId}`,
    UPDATE_PRODUCT: (productId) => `admin/products/update/${productId}`,

    GET_ORDERS: "admin/orders",
    EXPORT_ORDERS: "admin/orders/export",
    DELETE_ORDER: "admin/orders",
    UPDATE_ORDER_STATUS: "admin/orders/change-status",
    
    GET_EMAIL_TEMPLATES: "admin/email-templates",
    UPDATE_EMAIL_TEMPLATE: (key) => `admin/email-templates/${key}`,

    GET_FREE_TAPES: "admin/free-tapes",
    UPDATE_FREE_TAPE_STATUS: (tapeId) => `admin/free-tapes/approve/${tapeId}`,
});
